<div *ngIf="isGroupHeader" class="group-header">
	<div class="left-content">
		<mat-icon [ngClass]="expanded ?'drop-down-rotate-down':'drop-down-rotate-right'" svgIcon="md:drop_down"
				(click)="expandPanel()"></mat-icon>
		<mat-icon *ngIf="!isFC" svgIcon="non-fully-configured" [matTooltip]="('eorder.product.type.nfc' | translate)"></mat-icon>
		<mat-icon *ngIf="isFC" svgIcon="fully-configured" [matTooltip]="('eorder.product.type.fc' | translate)"></mat-icon>
		<span class="group-header-name width-content" [matTooltip]="groupHeaderName">{{ groupHeaderName }}</span>
		<a *ngIf="!isFC" class="template-variable" (click)="$event.preventDefault();openPopup($event)" href="#">
			<span>{{variableList.length}}</span>&nbsp;<span translate>eorder.product.variables</span>
		</a>
	</div>
	<div *ngIf="!isFC">
		<span translate>eorder.product.lastused</span>&nbsp;
		<span translate>eorder.product.lastused.default</span>
	</div>
	<div *ngIf="!isFC" class="right-content">
		<div class="right-content-field">
			<input class="copo-offer-text-align-right add-to-cart-input" matInput copoInputNumber type="number"
				[formControl]="numberControl" [min]="1" [decimalCount]="0" value="1" />
			<mat-icon class="pencil-icon pencil-icon-white" svgIcon="copo_pencil"></mat-icon>
		</div>
		<div class="ag-add-to-cart">
			<button (click)="addToCart()" type="button" class="add-to-cart-btn" mat-flat-button color="primary">
				<span class="add-to-cart-btn-name" translate>eorder.product.template.add.to.cart</span>
			</button>
		</div>
	</div>
</div>
<div *ngIf="isEmptyRow" class="empty-row">
	<span translate>eorder.product.empty.row</span>
</div>